import React from 'react';
import { PASSWORD_RULES } from '@/features/auth/registration/schema';

interface PasswordRequirementsProps {
  show: boolean;
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({
  show,
}) => {
  if (!show) return null;

  return (
    <div className="text-sm text-destructive mt-1.5">
      <p className="font-medium">Password requirements:</p>
      <ul className="list-disc pl-5 mt-1 space-y-0.5">
        {PASSWORD_RULES.map(rule => (
          <li key={rule.label}>{rule.label}</li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordRequirements;
